<template>
  <div class="lateness-cell">
    <div
      v-for="(latenessValue, index) in record.lateness.value"
      :key="`lateness-cell-${index}`"
      class="lateness-cell-item"
      :class="{
        'lateness-cell-item-border-left-grey': index === 3 && latenessValue > 0,
        'lateness-cell-item-border-left-white': latenessValue > 0 && index !== 0,
      }"
      :style="{ 'background-color': getLatenessColor(index, latenessValue) }"
    >
      {{ latenessValue === 0 ? "" : latenessValue }}
    </div>
  </div>
</template>

<script>
export default {
  name: "lateness-cell",
  props: ["record", "calcData"],
  methods: {
    getLatenessColor(index, value) {
      if (index === 3 && this.record.isSumRow && value > 0) {
        return "#f5f7fa";
      }
      if (value === 0) {
        return "#FFFFFF";
      }
      let color = "#FFFFFF";
      if (this.calcData !== null) {
        switch (index) {
          case 0:
            color = this.calcData.color_settings[2].min_color;
            break;
          case 1:
            color = this.calcData.color_settings[2].middle_color;
            break;
          case 2:
            color = this.calcData.color_settings[2].max_color;
            break;
          default:
            color = "#FFFFFF";
        }
      }
      return color;
    },
  },
};
</script>

<style lang="scss" scoped>
.lateness-cell {
  display: flex;
  align-items: center;
  line-height: 13px;
  font-size: 13px;
  height: 100%;
  width: 100%;
  -webkit-transition: font 0.3s ease;
  transition: font 0.3s ease;

  &-item {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    min-width: 25px;
    height: 100%;
    width: 25%;
    text-align: center;

    &-border-left-grey {
      border-left: 1px solid #dfe4ef;
    }
    &-border-left-white {
      border-left: 1px solid #ffffff;
    }
  }
}
</style>
